import { IntegrationsMarketplaceHistoryLogsBaseDataProvider } from './IntegrationsMarketplaceHistoryLogsBaseDataProvider';
import {HistoryLogEntry} from "../types";
import {ConsoleRequest, DataProviderEntity, DataProviderType} from "../../../utils/request";

export class IntegrationsMarketplaceHistoryLogsGzDataProvider extends IntegrationsMarketplaceHistoryLogsBaseDataProvider {
  public async clearLogs(integrationId: string) {
    try {
      const response = await ConsoleRequest.createRequest<{success: boolean}>({
        dataProviderType: DataProviderType.ENDPOINTS,
        dataProviderEntity: DataProviderEntity.MODEL,
        endpoint: 'IntegrationLogs',
        method: 'clearLogs',
        payload: {
          integrationId,
        },
      });

      return response;
    } catch (error) {
      console.error(error);
      return {success: false};
    }
  }

  public async getLogs(integrationId: string) {
    try {
      const response = await ConsoleRequest.createRequest<{records: HistoryLogEntry[]}>({
        dataProviderType: DataProviderType.ENDPOINTS,
        dataProviderEntity: DataProviderEntity.MODEL,
        endpoint: 'IntegrationLogs',
        method: 'getLogs',
        payload: {
          integrationId,
        },
      });

      return {success: true, logs: response.records};
    } catch (error) {
      console.error(error);
      return {success: false, logs: []};
    }
  }
}
